import React from 'react';
import {Router, Route, IndexRoute, hashHistory} from 'react-router';
import Header from '../Header';
import Download from '../Download';
import Home from '../Home'
import Buy from '../Buy'
import BuyResult from '../BuyResult'
import Support from '../Support'
import DocsCustomFormat from '../DocsCustomFormat'
import DocsProduceGraphs from '../DocsProduceGraphs'

class MainRouter extends React.Component {
	render() { 
		return (
				<Router history={hashHistory}>
					<Route path='/' component={Header}>
						<Route path='/releases' component={Download}/>
						<Route path='/buy' component={Buy}/>
						<Route path='/buy-result' component={BuyResult}/>
						<Route path='/support' component={Support}/>

						<Route path='/docs/custom-log-format' component={DocsCustomFormat}/>
						<Route path='/docs/producing-graphs' component={DocsProduceGraphs}/>
						<Route path='/docs/how-tos' component={Support}/>
	
						<IndexRoute component={Home}/>
					</Route>
				</Router>
			);
	}
}

export default MainRouter;


// WEBPACK FOOTER //
// ./src/config/routes.js